/**
 * Callout blocks (lexicalNodes/CalloutNode.js, documents redesign 2.5) in
 * Markdown: GitHub's alert syntax, so a callout reads as a callout on GitHub /
 * GitLab and in any editor:
 *
 *   > [!NOTE]          info
 *   > [!WARNING]       warning
 *   > [!TIP]           success
 *   > the callout's text
 *
 * Reading also accepts GitHub's other two marks ([!IMPORTANT] → info,
 * [!CAUTION] → warning) for files written elsewhere; Apiboo never writes them.
 */
import { marked } from 'marked';

export const CALLOUT_MARK = Object.freeze({ info: 'NOTE', warning: 'WARNING', success: 'TIP' });
const KIND_OF_MARK = { NOTE: 'info', TIP: 'success', WARNING: 'warning', IMPORTANT: 'info', CAUTION: 'warning' };
const MARK_LINE = /^\s*\[!(NOTE|TIP|WARNING|IMPORTANT|CAUTION)\][ \t]*(?:\n|$)/i;

/** One callout block as Markdown; `inline` is its content already rendered. */
export function calloutToMarkdown(kind, inline) {
  const mark = CALLOUT_MARK[kind] || CALLOUT_MARK.info;
  const lines = String(inline || '') ? String(inline).split('\n').map((l) => `> ${l}`) : [];
  return [`> [!${mark}]`, ...lines].join('\n');
}

/**
 * A blockquote token that is a callout → `{ kind, tokens }` (the block tokens
 * of its text, without the mark line), else null.
 */
export function calloutOf(tok) {
  const m = MARK_LINE.exec(String(tok?.text || ''));
  if (!m) return null;
  const rest = String(tok.text).slice(m[0].length);
  return { kind: KIND_OF_MARK[m[1].toUpperCase()], tokens: rest.trim() ? marked.lexer(rest, { gfm: true }) : [] };
}
